import {
  MANPOWER_PLANNING_FETCHING,
  MANPOWER_PLANNING_FAILED,
  MANPOWER_PLANNING_SUCCESS,
} from "../actions/types";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MANPOWER_PLANNING_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case MANPOWER_PLANNING_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    case MANPOWER_PLANNING_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}